import type { AnyAction } from '@reduxjs/toolkit';

import { setWebRTCConnectionStatus } from '../../store/slices/audioV2';

type Dispatch = (action: AnyAction) => void;

export const handleTauriWebRTCConnectionStateChange = (payload: string, dispatch: Dispatch) => {
  const state = payload.toLowerCase() as RTCPeerConnectionState;
  dispatch(setWebRTCConnectionStatus(state));
};
